import { FormEvent } from 'react';
import { Col, ControlLabel, FormControl, FormGroup, HelpBlock, Row } from 'react-bootstrap';
import { IValidation } from './validation';

interface IProps {
    recipientHaveOrganQualityConcerns: number
    recipientOrganQualityConcernDetails: string,
    recipientDidOrganFunctionImmediately: number,
    recipientIsOrganCurrentlyFunctioning: number,
    validation: IValidation,
    dirty: boolean,
    viewOnly: boolean,
    onFieldChange: (e: FormEvent<FormControl & HTMLInputElement & HTMLTextAreaElement & HTMLSelectElement>) => void
}

const RecipientCenterQuestions = (props: IProps) => {
    return (
        <>
            <FormGroup validationState={props.dirty && props.validation.recipientHaveOrganQualityConcerns == false ? 'error' : null}>
                <ControlLabel>Were there organ quality concerns?</ControlLabel>
                <FormControl
                    componentClass='select'
                    name='recipientHaveOrganQualityConcerns'
                    style={{ width: 'auto' }}
                    disabled={props.viewOnly}
                    value={props.recipientHaveOrganQualityConcerns}
                    onChange={props.onFieldChange}
                >
                    <option value={-1}>- Select -</option>
                    <option value={1}>Yes</option>
                    <option value={2}>No</option>
                </FormControl>

                {props.dirty && props.validation.recipientHaveOrganQualityConcerns == false && (
                    <HelpBlock>
                        This is required
                    </HelpBlock>
                )}
            </FormGroup>

            <FormGroup validationState={props.dirty && props.validation.recipientOrganQualityConcernDetails == false ? 'error' : null}>
                <ControlLabel>What quality concerns were there?</ControlLabel>
                <FormControl
                    componentClass='textarea'
                    name='recipientOrganQualityConcernDetails'
                    style={{ resize: 'none' }}
                    cols={150}
                    rows={3}
                    placeholder='Please write a short description of the concerns. If there is nothing to report, type “N/A.”'
                    disabled={props.viewOnly}
                    value={props.recipientOrganQualityConcernDetails}
                    onChange={props.onFieldChange} />

                {props.dirty && props.validation.recipientOrganQualityConcernDetails == false && (
                    <HelpBlock>
                        This is required
                    </HelpBlock>
                )}
            </FormGroup>

            <Row>
                <Col xs={12} lg={3}>
                    <FormGroup validationState={props.dirty && props.validation.recipientDidOrganFunctionImmediately == false ? 'error' : null}>
                        <ControlLabel>Did the organ have immediate function?</ControlLabel>
                        <FormControl
                            componentClass='select'
                            name='recipientDidOrganFunctionImmediately'
                            style={{ width: 'auto' }}
                            disabled={props.viewOnly}
                            value={props.recipientDidOrganFunctionImmediately}
                            onChange={props.onFieldChange}
                        >
                            <option value={-1}>- Select -</option>
                            <option value={1}>Yes</option>
                            <option value={2}>No</option>
                        </FormControl>

                        {props.dirty && props.validation.recipientDidOrganFunctionImmediately == false && (
                            <HelpBlock>
                                This is required
                            </HelpBlock>
                        )}
                    </FormGroup>
                </Col>
                <Col xs={12} lg={9}>
                    <FormGroup validationState={props.dirty && props.validation.recipientIsOrganCurrentlyFunctioning == false ? 'error' : null}>
                        <ControlLabel>Does the organ currently have function?</ControlLabel>
                        <FormControl
                            componentClass='select'
                            name='recipientIsOrganCurrentlyFunctioning'
                            style={{ width: 'auto' }}
                            disabled={props.viewOnly}
                            value={props.recipientIsOrganCurrentlyFunctioning}
                            onChange={props.onFieldChange}
                        >
                            <option value={-1}>- Select -</option>
                            <option value={1}>Yes</option>
                            <option value={2}>No</option>
                        </FormControl>

                        {props.dirty && props.validation.recipientIsOrganCurrentlyFunctioning == false && (
                            <HelpBlock>
                                This is required
                            </HelpBlock>
                        )}
                    </FormGroup>
                </Col>
            </Row>
        </>
    );
}

export default RecipientCenterQuestions;